import React, { useMemo } from 'react'

import { LntButton, LntDivider } from '@app/components/base'
import { Show } from '@app/components/util'

import { isObject } from '@app/typeGuards'
import { objectMerge } from '@app/utils/object'

import styles from './styles.module.scss'

import { defaultAcceptButton, defaultResetButton } from './constants'

import type { ToolbarProps } from './types'

export const Toolbar: React.FC<ToolbarProps> = ({ toolbar, onReset }) => {
  if (!toolbar) {
    return null
  }

  const { accept, reset } = toolbar

  if (!accept && !reset) {
    return null
  }

  const acceptButtonProps = useMemo(
    () => (isObject(accept) ? objectMerge(defaultAcceptButton, accept) : defaultAcceptButton),
    [toolbar]
  )

  const resetButtonProps = useMemo(
    () => (isObject(reset) ? objectMerge(defaultResetButton, reset) : defaultResetButton),
    [toolbar]
  )

  return (
    <>
      <LntDivider
        removeMargins
        type='horizontal'
      />

      <div className={ styles.toolbar }>
        <Show condition={ !!accept }>
          <LntButton { ...acceptButtonProps }>Применить</LntButton>
        </Show>

        <Show condition={ !!reset }>
          <LntButton
            { ...resetButtonProps }
            onClick={ onReset }
          >
            Сбросить
          </LntButton>
        </Show>
      </div>
    </>
  )
}
